import React from 'react';
import { Box, Typography } from '@mui/material';
import textMaskElement from '../../assets/img/mobileLanding/text-masl-ele-2.png'
import teamPhoto from '../../assets/img/mobileLanding/team-photo.jpg';
import teamPhotoWeb from '../../assets/img/mobileLanding/team-photo-web.jpg';
import useDevice from 'hooks/useDevice';

function OurTeam({ type }: { type: 'web' | 'mobile' }) {
    const { screenWidth } = useDevice();
    return (
        <Box
            sx={{
                backgroundColor: 'white',
                padding: screenWidth < 400 ? '10px 0px' : '60px 0px',
                textAlign: 'center',
                position: 'relative',
                ...(type === 'web' ? { mb: 22 } : { mb: 5 })
            }}
        >
            <Box sx={{
                textAlign: 'left',
                width: screenWidth < 330 ? "100%" : "80%",
                margin: "auto",
                px: 2.2,
                zIndex: 1,
                position: "relative"
            }}>

                {/* Heading Text */}
                <Typography
                    variant="h4"
                    className='font-satoshi-light'
                    sx={{
                        color: '#0B1E53',
                        fontSize: '24px',
                        fontWeight: 400,
                        lineHeight: '139%',
                        letterSpacing: '0%',
                        textAlign: 'left',
                    }}
                >
                    Over the last{' '}
                    <Box component="span" className='font-satoshi-bold' sx={{ fontWeight: 700 }}>
                        8  years,
                    </Box>{' '}
                </Typography>

                <Typography
                    variant="h3"
                    className='font-satoshi-light'
                    sx={{
                        color: '#0B1E53',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: '139%',
                        letterSpacing: '0%',
                        textAlign: 'left',
                    }}
                >
                    Our team has
                    <br />
                    successfully delivered
                </Typography>

                {/* Large Number with Highlight */}
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: "fit-content",
                        whiteSpace: "nowrap"
                    }}
                >
                    <Typography
                        variant="h1"
                        className='font-satoshi-bold'
                        sx={{
                            position: 'relative',
                            color: '#0B1E53',
                            fontSize: '35.02px',
                            fontWeight: 700,
                            letterSpacing: '0%',
                            zIndex: 1,
                        }}
                    >
                        380<Box component="sup" className='font-satoshi-bold' sx={{ fontSize: '18.67px', fontWeight: 700, top: "-14px" }}>+</Box>
                    </Typography>
                    <Typography
                        variant="h4"
                        className='font-satoshi-light'
                        sx={{
                            color: '#0B1E53',
                            fontSize: '24px',
                            fontWeight: 700,
                            letterSpacing: '0%',
                            mx: 1,
                            zIndex: 1,
                        }}
                    >
                        projects for clients
                    </Typography>

                    <Box
                        component="img"
                        src={textMaskElement}
                        alt="Best Software Company Malappuram"
                        title="Best Software Company Malappuram"
                        sx={{
                            position: 'absolute',
                            top: '13px',
                            left: '-13px',
                            width: '185px',
                            height: '30px',
                        }}
                    />
                </Box>

                <Typography
                    variant="h4"
                    className='font-satoshi-light'
                    sx={{
                        color: '#0B1E53',
                        fontSize: '24px',
                        lineHeight: '139%',
                        letterSpacing: '0%',
                        textAlign: 'left',
                    }}
                >
                    across the globe.
                </Typography>
            </Box>


            {type === 'web' ?
                <Box
                    component="img"
                    src={teamPhotoWeb}
                    alt="Osperb Software Development Team Kerala"
                    title="Osperb Software Development Team Kerala - Custom ERP & Web Apps"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        position: 'absolute',
                        top: '0px',
                    }}
                />
                :
                <Box
                    component="img"
                    src={teamPhoto}
                    alt="Osperb Custom Software Development Team Malappuram"
                    title="Osperb Custom Software Development Team Malappuram"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        mt: -4,
                        zIndex: 0,
                        position: 'relative',
                    }}
                />}
        </Box>
    );
}

export default OurTeam;
